
import React from "react";
import Navbar from "@/components/layout/Navbar";
import { Toaster } from "@/components/ui/toaster";
import NoteRefinementComponent from "@/components/session/NoteRefinementComponent";

const NoteRefinementPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="mobile-container w-full py-4 sm:py-6">
        <Navbar />
        <main className="flex-1 overflow-y-auto mt-4 sm:mt-6">
          <div className="max-w-6xl mx-auto">
            <NoteRefinementComponent />
          </div>
        </main>
      </div>
      <Toaster />
    </div>
  );
};

export default NoteRefinementPage;
